import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useProviderUsers } from '@/hooks/useProviderUsers'
import { Skeleton } from '@/components/ui/skeleton'
import { ProviderUserDialog } from './ProviderUserDialog'
import { useViewMode } from '@/stores/viewMode'
import { PageHeader } from '@/components/PageHeader'
import IfAnyPermission from '@/components/IfAnyPermission'
import { AllowedAction } from '@/data/allowedActions'

export default function ProviderUsersPage() {
  const { id: providerId } = useViewMode()

  const [page] = useState(1)
  const [pageSize] = useState(10)
  const [account, setAccount] = useState('')
  const [showAddDialog, setShowAddDialog] = useState(false)

  const { providerUsers, isLoading, isError, mutate } = useProviderUsers({
    page,
    pageSize,
    provider_id: providerId ?? undefined,
    account,
  })

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">載入 Provider 使用者列表失敗。請稍後再試。</div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Provider 使用者管理"
        description="管理 Provider 使用者帳號"
        level="section"
      >
        <IfAnyPermission
          permissions={[
            { module: 'provider_user_management', action: AllowedAction.C },
          ]}
        >
          <Button onClick={() => setShowAddDialog(true)}>
            <Plus className="mr-2 h-4 w-4" />
            新增 Provider 使用者
          </Button>
        </IfAnyPermission>
      </PageHeader>

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={providerUsers || []}
            onSearch={setAccount}
            meta={{
              reloadData: () => mutate(),
            }}
          />
        </CardContent>
      </Card>

      <ProviderUserDialog
        open={showAddDialog}
        onOpenChange={setShowAddDialog}
        providerId={providerId}
        onSuccess={() => mutate()}
      />
    </div>
  )
}
